import React from 'react'
import { LOCALE } from "../../../constants/activity-constants";

const ec = LOCALE === "es-EC"
const arg = LOCALE === "es-AR"

export let textCountry = {};

if (arg) {
  textCountry = {
    text1: 'Tenés'
  }
}else{
  textCountry = {
    text1: 'Tienes'
  }
}

const Text1ByCountry = () => {
  let text;
if(arg){
    text = <>
      <b>Comenzá a participar, </b> para que logres gobernar toooodo el
      Universo Nosotras. <br /> Avanzá sin miedo,{' '}
      <b>descubrí los 3 planetas</b> y acumulá tooodos los puntos posibles.{' '}
      <br />
      <b>Demostrá tus habilidades y disfrutá como nunca.</b>
    </>
  }else{
    text = <>
      <b>Comienza a participar, </b> para que logres gobernar toooodo el
      Universo Nosotras. <br /> Avanza sin miedo,{' '}
      <b>descubre los 3 planetas</b> y acumula tooodos los puntos posibles.{' '}
      <br />
      <b>Demuestra tus habilidades y disfruta como nunca.</b>
    </>
  }

  return (
    text
  )
}
export const text_replica_content_proifile1 = Text1ByCountry()
